import { IComponentOptions } from 'angular';
import { ManageUsersHeaderCtrl } from './manage-users-header.controller';

export const ManageUsersHeaderComponent: IComponentOptions = {
  bindings: {
    sharedState: '<',
    addNewSchoolUser: '&',
    isUserSelected: '&',
    getSelectedUsers: '&',
    updateUsersDelegatedRole: '&',
    selectedUsersHash: '<',
    school: '<',
  },
  controller: ManageUsersHeaderCtrl,
  template: require('./manage-users-header.html'),
};
